/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/product-engineering.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/product-engineering.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/product-engineering.mdx';

const metadata = {
  slug: "product-engineering",
  title: "Product Engineering",
  author: "Christian Battaglia",
  description: "A deep exploration of what \"product engineering\" means — from my own experience building tools at Amplify to the traits, mindset, and laws that define engineers who engage with the \"why\" beyond the code.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-19T00:00:00.000Z",
  
  readTime: "8 min read",
  tags: ["product engineering","software engineering","Amplify","product management","engineering leadership","career","product-minded engineer","EdTech"],
};

export const Route = createFileRoute('/blog/posts/product-engineering')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/product-engineering',
    image: '/og/blog/product-engineering.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
